import Task1 from '../pages/Task1/Task';


const publicRoutes = [
    {path : '/task1', component : <Task1 />}
]

export {publicRoutes};
